import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import Spin from '@music/mobile-loading';
import '@music/mobile-loading/dist/index.css';

import { retry } from '@lib/util';
import ErrorBoundary from '@component/ErrorBoundary';

const App = React.lazy(() => retry(() => import(`./${process.env.PAGE}/index`)));

function Loadable() {
    return (
        <ErrorBoundary>
            <Suspense fallback={<Spin text="加载中..." />}>
                <App />
            </Suspense>
        </ErrorBoundary>
    );
}

ReactDOM.render(<Loadable />, document.getElementById('app'));
